import { render, staticRenderFns } from "./NikkudOptions.vue?vue&type=template&id=4c1e0462&scoped=true"
import script from "./NikkudOptions.vue?vue&type=script&lang=js"
export * from "./NikkudOptions.vue?vue&type=script&lang=js"
import style0 from "./NikkudOptions.vue?vue&type=style&index=0&id=4c1e0462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e0462",
  null
  
)

export default component.exports